export default "__VITE_ASSET__3243b141__"